import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BaseApi } from '@core/base/base-api';
import { NotificationService } from '@core/services/notification.service';
import { Observable, Subscription } from 'rxjs';
import { map } from 'rxjs/operators';

import { ApiUtil } from '../util/api.util';

import { Asset } from './asset';

@Injectable({
  providedIn: 'root',
})
export class AssetApi extends BaseApi<Asset> {
  constructor(
    httpClient: HttpClient,
    private notificationService: NotificationService,
  ) {
    super(httpClient, 'assets');
  }

  create(): Asset {
    return new Asset();
  }

  get(uuid: string): Observable<Asset> {
    return this.httpClient.get<Asset>(`${this.endpoint}/${uuid}`);
  }

  setDocumentType(uuid: string, documentType: string): Observable<boolean> {
    return this.httpClient
      .put(`${this.endpoint}/${uuid}/documentType/${documentType}`, {}, { observe: 'response' })
      .pipe(map(value => value.status === 202));
  }

  getImage(uuid: string): Observable<string> {
    return this.httpClient
      .get(`${this.endpoint}/${uuid}/download`, {
        responseType: 'arraybuffer',
        observe: 'response',
        headers: new HttpHeaders({
          // eslint-disable-next-line @typescript-eslint/naming-convention
          'Content-Type': 'application/json',
        }),
      })
      .pipe(
        map(response => {
          const base64String = ApiUtil.arrayBufferToBase64(response.body);

          return `data:${response.headers.get('content-type')};base64,${base64String}`;
        }),
      );
  }

  downloadFile(uuid: string, toastMessage?: string): Subscription {
    if (!toastMessage) {
      toastMessage = 'Bezig met downloaden bestand';
    }

    this.notificationService.info(toastMessage, '');

    return this.httpClient
      .get(`${this.endpoint}/${uuid}/download`, {
        responseType: 'blob',
        observe: 'response',
        headers: new HttpHeaders({
          // eslint-disable-next-line @typescript-eslint/naming-convention
          'Content-Type': 'application/json',
        }),
      })
      .subscribe(
        response => {
          ApiUtil.saveToFileSystem(response);
          this.notificationService.clear();
          this.notificationService.success('Bestand gedownload', 'Success');
        },
        response => {
          console.error(`[AssetService] downloadFile: error downloading file:`, response.error.message);
        },
      );
  }
}
